import { initMatomo, trackEvent, trackApiRequest, setUserId } from "./matomo";

// Only run this helper code in production:
if (process.env?.REACT_APP_RUN_ENV === "production") {
  // 1) Initialize Matomo right away (will bail out inside initMatomo() if not prod)
  initMatomo();

  // 2) Print console helper instructions
  console.log("Matomo Console Helper");
  console.log("Verfügbare Befehle:");
  console.log("▶ trackEvent('Kategorie', 'Aktion', 'Name', Wert)  -> Trackt ein Event");
  console.log("▶ trackApiRequest('/api/example', 'Success')      -> Trackt API-Anfragen");
  console.log("▶ setUserId('benutzer123')                        -> Setzt eine Benutzer-ID");
  console.log("▶ trackDownload('/path/to/file.pdf')              -> Trackt Datei-Downloads");

  // 3) Expose helper functions globally for quick debugging
  (window as any).trackEvent = trackEvent;
  (window as any).trackApiRequest = trackApiRequest;
  (window as any).setUserId = setUserId;
} else {
  // If you want, you can log something in dev to confirm it’s disabled, or do nothing:
   console.debug("[matomoConsole] Skipped in development mode.");
}
